import { useState } from 'react';
import { useAppData } from '../context/AppDataContext.jsx';

function formatHHMM(iso) {
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

function nowHHMM() {
  const d = new Date();
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

// Combina YYYY-MM-DD + HH:MM in un ISO datetime (timezone locale)
function toIso(dateStr, hhmm) {
  const [h, m] = hhmm.split(':').map(Number);
  const d = new Date(`${dateStr}T00:00:00`);
  d.setHours(h, m, 0, 0);
  return d.toISOString();
}

export default function MedIntakeRow({ med, intakes, date }) {
  const { addIntake, removeIntake, updateIntake } = useAppData();
  const [showCustom, setShowCustom] = useState(false);
  const [time, setTime] = useState(nowHHMM());
  const [busy, setBusy] = useState(false);

  async function takeNow() {
    setBusy(true);
    try {
      await addIntake(med.id);
    } finally {
      setBusy(false);
    }
  }

  async function takeAtCustom() {
    setBusy(true);
    try {
      await addIntake(med.id, toIso(date, time));
      setShowCustom(false);
    } finally {
      setBusy(false);
    }
  }

  async function changeTime(intake) {
    const current = formatHHMM(intake.takenAt);
    const next = window.prompt(`Nuovo orario per ${med.name} (HH:MM)`, current);
    if (!next || next === current) return;
    if (!/^\d{2}:\d{2}$/.test(next)) return;
    await updateIntake(intake.id, { takenAt: toIso(intake.date, next) });
  }

  async function del(intake) {
    if (!window.confirm(`Eliminare l'assunzione delle ${formatHHMM(intake.takenAt)}?`)) return;
    await removeIntake(intake.id);
  }

  return (
    <div className="med-intake">
      <div className="med-intake-head">
        <div className="med-intake-name">
          <strong>{med.name}</strong>
          {med.dose && <span className="dose"> · {med.dose}</span>}
        </div>
        <div className="row">
          <button onClick={takeNow} disabled={busy}>+ ora</button>
          <button
            className="secondary"
            onClick={() => setShowCustom((v) => !v)}
            disabled={busy}
          >
            +…
          </button>
        </div>
      </div>

      {showCustom && (
        <div className="row" style={{ marginTop: '0.4rem' }}>
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            style={{ maxWidth: 130 }}
          />
          <button onClick={takeAtCustom} disabled={busy}>Salva</button>
          <button className="secondary" onClick={() => setShowCustom(false)}>Annulla</button>
        </div>
      )}

      {intakes.length > 0 && (
        <div className="intakes">
          {intakes.map((i) => (
            <span key={i.id} className="intake-chip" title={`Tocca per modificare`}>
              <button
                className="btn-link"
                onClick={() => changeTime(i)}
                style={{ padding: 0 }}
              >
                {formatHHMM(i.takenAt)}
              </button>
              <button
                className="btn-link"
                onClick={() => del(i)}
                style={{ padding: 0, color: '#c0392b' }}
                aria-label="Elimina"
                title="Elimina"
              >
                &times;
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
